var map = {
	"./acl/reducer": "./src/modules/acl/reducer.js",
	"./actionButton/reducer": "./src/modules/actionButton/reducer.js",
	"./authentication/reducer": "./src/modules/authentication/reducer.js",
	"./changelogs/reducer": "./src/modules/changelogs/reducer.js",
	"./core/reducer": "./src/modules/core/reducer.js",
	"./dashboards/reducer": "./src/modules/dashboards/reducer.js",
	"./devices/reducer": "./src/modules/devices/reducer.js",
	"./documents/reducer": "./src/modules/documents/reducer.js",
	"./errorBoundary/reducer": "./src/modules/errorBoundary/reducer.js",
	"./footbar/reducer": "./src/modules/footbar/reducer.js",
	"./groups/reducer": "./src/modules/groups/reducer.js",
	"./layout/reducer": "./src/modules/layout/reducer.js",
	"./logs/reducer": "./src/modules/logs/reducer.js",
	"./messaging/reducer": "./src/modules/messaging/reducer.js",
	"./navbar/reducer": "./src/modules/navbar/reducer.js",
	"./nfcs/reducer": "./src/modules/nfcs/reducer.js",
	"./notification/reducer": "./src/modules/notification/reducer.js",
	"./qrcodes/reducer": "./src/modules/qrcodes/reducer.js",
	"./rounds/reducer": "./src/modules/rounds/reducer.js",
	"./subscriptions/reducer": "./src/modules/subscriptions/reducer.js",
	"./templates/reducer": "./src/modules/templates/reducer.js",
	"./tickets/reducer": "./src/modules/tickets/reducer.js",
	"./users/reducer": "./src/modules/users/reducer.js",
	"./workspace/reducer": "./src/modules/workspace/reducer.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/modules sync recursive ^\\.\\/.*\\/reducer$";